// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import DateFNS from 'date-fns';
import MaskedInput from 'react-text-mask';
// local
// css
import './DatePicker.scss';
// view
import DateContent from './DateContent';
// lib
import { DATE_MASK } from 'app/lib/masks';
import { isValidDate, fromUTC } from 'app/lib/helper';

class DatePicker extends Component {
    constructor(props) {
        super(props);
        this.state = this.initState(props.value);
    }

    initState(value) {
        const aux = new Date(value);
        const date = value && isValidDate(aux) ? fromUTC(aux, true) : null;
        const inputValue = date ? DateFNS.format(date, 'DD/MM/YYYY') : '';
        return {
            isOpen: false,
            date,
            inputValue,
        };
    }

    stringToDate(string) {
        const res = string.match(/([0][1-9]|[12][0-9]|3[01])\/([0][1-9]|[1][0-2])\/(\d{4})/);
        if (res) {
            let date = DateFNS.setDate(new Date(), res[1]);
            date = DateFNS.setMonth(date, res[2] - 1);
            date = DateFNS.setYear(date, res[3]);
            date = fromUTC(date, true);
            return isValidDate(date) ? date : null;
        } else {
            return null;
        }
    }

    onBlurInput = event => {
        const { value } = event.target;
        const date = this.stringToDate(value);
        // clear the input when the focus is lost and the value is not a valid date
        if (!date) {
            this.setState({
                date: null,
                inputValue: '',
            });
        } else {
            this.setState({
                date,
                inputValue: DateFNS.format(date, 'DD/MM/YYYY'),
            });
        }
    };

    onClickInput = () => this.setState({ isOpen: true });

    onOpenPopup = () => this.setState({ isOpen: true });

    onClosePopup = () => this.setState({ isOpen: false });

    onChangeInput = (e, target) => {
        const { value } = target || e.target;
        const date = this.stringToDate(value);
        this.setState({ date, inputValue: value });
        const { onChange } = this.props;
        if (onChange) {
            onChange(date ? date.getTime() : null);
        }
    };

    onSelectDate = date => {
        const value = DateFNS.format(date, 'DD/MM/YYYY');
        this.setState({ date, inputValue: value, isOpen: false });
        const { onChange } = this.props;
        if (onChange !== null) {
            onChange(date.getTime());
        }
    };

    render() {
        const { date, inputValue, isOpen } = this.state;
        const { id, error } = this.props;
        const errorClass = error ? 'error' : '';
        const className = ['field', 'datepicker', errorClass].filter(s => s.length > 0).join(' ');
        const trigger = (
            <div className={className}>
                <MaskedInput
                    mask={DATE_MASK}
                    placeholder="DD/MM/AAAA"
                    guide
                    onBlur={this.onBlurInput}
                    onClick={this.onClickInput}
                    onChange={this.onChangeInput}
                    value={inputValue}
                    render={(ref, props) => <input ref={ref} value={inputValue} {...props} />}
                />
            </div>
        );
        const content = <DateContent id={id} value={date} onSelectDate={this.onSelectDate} />;
        return (
            <Popup
                open={isOpen}
                trigger={trigger}
                content={content}
                on="click"
                className="datepicker"
                position="bottom center"
                onClose={this.onClosePopup}
                onOpen={this.onOpenPopup}
            />
        );
    }
}

DatePicker.defaultProps = {
    value: null,
};

DatePicker.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.number,
    error: PropTypes.bool,
};

export default DatePicker;
